import { Button, ButtonProps } from "react-bootstrap";
import React, { FunctionComponent } from "react";
import { Link } from "react-router";
import "./Buttons.scss";

export const PrimaryButton: FunctionComponent<ButtonProps> = (props) => {
  return <Button {...props} className={`primary-button ${props.className || ""}`} />;
};

export const DeleteButton: FunctionComponent<ButtonProps> = (props) => {
  return <Button {...props} variant="danger" className={`delete-button ${props.className || ""}`} />;
};

export const BackButton: FunctionComponent<{
  to: string;
  className?: string;
}> = ({ to, className }: { to: string; className?: string }) => {
  return (
    <Link to={to}>
      <Button className={`back-button ${className || ""}`} variant="link">
        &lt; Zurück
      </Button>
    </Link>
  );
};
